'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const $ = require("jquery");
class Menu {
    constructor() {
        $('.trigMenu').on('click', () => {
            const isOpen = $('.paramMenu').attr('data-is-open');
            if (isOpen === 'false') {
                $('.bulletMenu').attr('data-is-open', 'true');
                $('.paramMenu').attr('data-is-open', 'true');
            }
            else {
                $('.bulletMenu').attr('data-is-open', 'false');
                $('.paramMenu').attr('data-is-open', 'false');
            }
        });
        $('.trigSearchWindow').on('click', (e) => {
            const action = $(e.currentTarget).attr('data-action');
            if (action === 'open') {
                $('.bulletSearchWindow').show();
            }
            else {
                $('.bulletSearchWindow').hide();
            }
        });
    }
    noScroll(e) {
        e.preventDefault();
    }
}
exports.Menu = Menu;
exports.default = Menu;
